<template>
  <div class="c-allocationResult">
    <PageTitle titleText="抽選結果"></PageTitle>
    <div class="c-allocationResult__Wrap">
      <div class="c-allocationResult__subTitle">
        {{ allocation ? allocation.name : "" }}
      </div>
      <div class="c-allocationResult__roomNumTitle">
        {{ currentUser.roomNo }}号室様の抽選結果
      </div>
      <div v-if="results.length === 0" class="c-allocationResult__roomNumTitle">
        お申し込みされていません。
      </div>
      <div class="c-allocationResult__rankCardsWrap">
        <div
          class="c-allocationResult__rankCards"
          :class="{
            'c-allocationResult__rankCards--2RowOrLess': results.length < 3,
          }"
        >
          <div
            v-for="(item, index) in results"
            :key="index"
            v-show="item.priority != null"
            class="c-allocationResult__rankCard"
          >
            <div class="c-allocationResult__order" v-if="!includesHikkoshi">
              {{ index + 1 }}台目
            </div>
            <div class="c-allocationResult__adise" v-if="!includesHikkoshi">
              割当優先順位
            </div>
            <div class="c-allocationResult__adise" v-if="includesHikkoshi">
              優先順位
            </div>
            <div class="c-allocationResult__num">{{ item.priority }}</div>
          </div>
        </div>
      </div>
      <div
        v-html="allocation ? allocation.result_text : ''"
        class="ck-content c-allocationResult__content"
      ></div>
    </div>
    <el-button @click="onBack">戻る</el-button>
  </div>
</template>

<script>
import AllocationService from "@/services/allocation.service";
import AllocationLotteryService from "@/services/allocation-lottery.service";
import PageTitle from "@/components/PageTitle.vue";

export default {
  name: "Lottery",
  components: {
    PageTitle,
  },
  data() {
    return {
      allocation: null,
      results: [],
    };
  },
  async mounted() {
    console.log("Lottery");
    const result = await AllocationService.find({
      where: {
        mansion: this.currentUser.mansion._id,
        status: "抽選結果公開",
      },
    });
    console.log("result", result);
    if (result.data.length > 0) {
      this.allocation = result.data.filter(allocation => {
        return allocation._id == this.$route.params.id;
      })[0];
    }
    console.log("allocation", this.allocation);
    console.log("this.$route.params.id", this.$route.params.id);
    const result2 = await AllocationLotteryService.find({
      where: {
        allocation: this.$route.params.id,
        status: "公開",
      },
    });
    console.log("result2", result2);
    if (result2.data.length > 0) {
      const allNormalizedEntries = result2.data[0].normalizedEntries;
      console.log("allNormalizedEntries", allNormalizedEntries);
      for (let index = 0; index < allNormalizedEntries.length; index++) {
        const normalizedEntries = allNormalizedEntries[index];
        const priority = normalizedEntries.filter(entry => {
          return entry.roomNo == this.currentUser.roomNo;
        })[0].priority;
        console.log(priority);
        this.results.push({ no: index, priority });
      }
      console.log("result3", this.results);
    }
  },
  methods: {
    onBack() {
      this.$router.push({ name: "allocation-index" });
    },
  },
  computed: {
    includesHikkoshi() {
      return this.allocation.name.includes("引越");
    },
  },
};
</script>
